import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { RosterType } from 'src/app/core/services/http/roster/enums/roster-types';
import { RosterUploadFileType } from "../../../../core/services/http/roster/enums/roster-upload-file-types";

@Component({
  selector: 'app-roster-general-settings',
  templateUrl: './roster-general-settings.component.html',
  styleUrls: ['./roster-general-settings.component.scss']
})
export class RosterGeneralSettingsComponent {
  @Input() form: UntypedFormGroup | undefined;
  rosterType = RosterType;
  rosterFileType = RosterUploadFileType;
}
